// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-tl4","delete":"styles_delete__1xxhN","update":"styles_update__11YST","add":"styles_add__1GerT"};